export const DEFAULT_REPORT_TIME_ZONE = 'UTC'

export type TimeZoneOption = { value: string, label: string }

export function isValidTimeZone(timeZone?: string) {
    if(!timeZone) return false
    try {
        new Intl.DateTimeFormat('en-US', { timeZone }).format(new Date())
        return true
    } catch {
        return false
    }
}

export function getBrowserTimeZone() {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    return isValidTimeZone(timeZone) ? timeZone : DEFAULT_REPORT_TIME_ZONE
}

export function resolveScheduledReportTimeZone(timeZone: string | undefined, isNew: boolean, browserTimeZone = getBrowserTimeZone()) {
    if(isValidTimeZone(timeZone)) return timeZone as string
    return isNew && isValidTimeZone(browserTimeZone) ? browserTimeZone : DEFAULT_REPORT_TIME_ZONE
}

export function getTimeZoneOptions(browserTimeZone = getBrowserTimeZone()): TimeZoneOption[] {
    const intlWithSupportedValues = Intl as typeof Intl & {
        supportedValuesOf?: (key: 'timeZone') => string[]
    }
    const supported = intlWithSupportedValues.supportedValuesOf?.('timeZone') || []
    const timeZones = Array.from(new Set([
        DEFAULT_REPORT_TIME_ZONE,
        browserTimeZone,
        ...supported,
    ].filter(isValidTimeZone)))

    return timeZones.map((timeZone) => ({ value: timeZone, label: timeZone }))
}
